import { bn, isAddressEqual } from "@opensea/utils"
import { isAddress } from "viem"
import { z } from "zod"
import {
  ADDRESS_VALIDATION_MESSAGES,
  addressSchema,
} from "../../../lib/zod/address"

export const sendFlowFormSchema = z
  .object({
    ownedQuantity: z.number(),
    quantity: z.string().superRefine((val, ctx) => {
      if (!bn(val).gt(0)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Amount must be greater than 0",
        })
      }
    }),
    recipient: addressSchema
      .superRefine(({ resolvedAddress, identifier, currentAddress }, ctx) => {
        const address = resolvedAddress ?? identifier

        if (
          address &&
          isAddress(address) &&
          isAddressEqual(address, currentAddress)
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: ADDRESS_VALIDATION_MESSAGES.cannotTransferToSelf,
            path: ["identifier"],
          })
        }
      })
      .superRefine(({ identifier }, ctx) => {
        if (!identifier) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Please enter a valid address or ENS name.",
            path: ["identifier"],
          })
        }
      }),
  })
  .superRefine((data, ctx) => {
    if (
      data.ownedQuantity &&
      Number(data.quantity) > Number(data.ownedQuantity)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["quantity"],
        message: "Not enough balance",
      })
    }
  })

export type SendFlowFormValues = z.infer<typeof sendFlowFormSchema>
